<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Reviewer Documents</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <!--<div class="page-create-button">
                            <router-link to="/modules/reviewerdocuments/edit" class="btn-create">Create</router-link>
                        </div>!-->
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/ReviewerDocuments/MenuList.vue";
    import lang from "@/views/modules/ReviewerDocuments/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomList from "@/views/modules/ReviewerDocuments/ListView.vue";
    import CustomSearch from "@/views/modules/ReviewerDocuments/SearchView.vue";
    export default {
        name: "new-reviewer-documents",
        components: {
            breadcrumbs,
            GenericList,
            CustomList,
            CustomSearch,
        },
        data() {
            return {
                generic: false,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_FILE_NAME,
                        link: true,
                        moduleName: 'ReviewerDocuments',
                        routePath: 'reviewerdocuments',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'file_name'

                    },
                    {
                        label: lang.LBL_ADDED_BY,
                        link: false,
                        moduleName: '',
                        routePath: '',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'user_name'

                    },
                    {
                        label: lang.LBL_DOWNLOAD_FILE,
                        link: false,
                        moduleName: '',
                        routePath: '',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'file_path'

                    },

                ],
                columns: ['name', 'head_sequence'],
            }
        },
        mounted() {
            this.childMethod();
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                } else {
                    if (search != '') {
                        this.$refs.loadCustom.getReviewerDocument(search);
                    }
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>